var _path, _path2, _path3, _path4, _circle, _path5, _polygon, _path6, _polygon2, _path7, _path8, _path9, _path10, _path11, _path12, _circle2, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _circle3, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _circle4, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPastcases(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 611.49618,
    height: 545,
    viewBox: "0 0 611.49618 545",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M297.877,683.38244c6.97183,15.94456,22.45956,25.70235,38.3179,33.634q3.32144,1.66162,6.63223,3.228c.01457.0042.03047.01518.04523.01951.10615.0499.2125.09991.312.1511.45547.215.91111.43014,1.36269.64248l-.215.13295-.67082.41042c.23234-.13273.46213-.26135.69447-.39408.06905-.04024.142-.07784.21088-.11824,8.00374-4.52878,16.1244-9.32872,21.75857-16.57417,5.84372-7.523,8.395-18.44726,3.60226-26.6803a16.784,16.784,0,0,0-2.22949-2.99524c-.35112-.3834-.72258-.74565-1.10614-1.0987a17.98976,17.98976,0,0,0-29.91386,9.47245c-2.38656-9.814,4.719-19.2394,11.80488-26.43783,7.08973-7.19578,15.1841-15.08157,15.40206-25.18395a19.46452,19.46452,0,0,0-6.55374-14.52947c-.12525-.11591-.25033-.23166-.37835-.34358a26.25441,26.25441,0,0,0-17.91643-6.76116c-12.28565.34406-23.20857,8.3165-30.89781,17.90761C295.76211,643.29627,289.95094,665.25346,297.877,683.38244Z",
    transform: "translate(-294.25191 -177.5)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M317.78729,658.686a44.6309,44.6309,0,0,0-3.7538,12.39261,38.75342,38.75342,0,0,0,.17346,11.52253,49.653,49.653,0,0,0,9.41108,21.54832,71.46189,71.46189,0,0,0,12.57685,12.867q3.32144,1.66162,6.63223,3.228c.01457.0042.03047.01518.04523.01951.10615.0499.2125.09991.312.1511.45547.215.91111.43014,1.36269.64248l-.215.13295-.67082.41042c.23234-.13273.46213-.26135.69447-.39408.06905-.04024.142-.07784.21088-.11824a39.5028,39.5028,0,0,1,8.06941-35.37736,39.84132,39.84132,0,0,1,15.06193-10.87235c-.35112-.3834-.72258-.74565-1.10614-1.0987a41.30751,41.30751,0,0,0-6.421,3.45226,40.47516,40.47516,0,0,0-15.82805,19.89211,41.38139,41.38139,0,0,0-1.48789,23.1028c-.389-.26884-.77942-.54446-1.15891-.81843a72.55923,72.55923,0,0,1-18.74572-18.68411,46.19226,46.19226,0,0,1-7.66205-21.03183c-.76779-8.22616,1.49009-16.23856,5.33828-23.46293a96.68992,96.68992,0,0,1,15.69189-21.13A109.86835,109.86835,0,0,1,357.07,618.11851a.78992.78992,0,0,0,.26111-1.05719.67191.67191,0,0,0-.37835-.34358.585.585,0,0,0-.50075.088c-.93608.59079-1.86441,1.18693-2.78214,1.80214A111.11547,111.11547,0,0,0,332.89756,636.632,89.45529,89.45529,0,0,0,317.78729,658.686Z",
    transform: "translate(-294.25191 -177.5)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M565.94487,547.78369a25.80322,25.80322,0,1,1,25.80322-25.80322A25.83231,25.83231,0,0,1,565.94487,547.78369Zm0-49.60644a23.80322,23.80322,0,1,0,23.80322,23.80322A23.83017,23.83017,0,0,0,565.94487,498.17725Z",
    transform: "translate(-294.25191 -177.5)",
    fill: "#c29879"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "f73b5929-bbea-48c2-a07c-236a7aa3f606-717",
    "data-name": "Path 395",
    d: "M563.48708,531.442a2.57246,2.57246,0,0,1-1.5476-.51433l-.02769-.02077-5.82907-4.45905a2.59039,2.59039,0,1,1,3.1521-4.11155l3.77561,2.8953,8.92195-11.63967a2.5893,2.5893,0,0,1,3.63033-.47952l.00075.00056-.05537.07689.05687-.07689a2.59244,2.59244,0,0,1,.47895,3.63106L565.54974,530.4287a2.59083,2.59083,0,0,1-2.06038,1.01021Z",
    transform: "translate(-294.25191 -177.5)",
    fill: "#c29879"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 180.36691,
    cy: 190.59345,
    r: 24.56103,
    fill: "#a0616a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M465.75113,513.42549q-.464,0-.93213-.041a11.00261,11.00261,0,0,1-9.875-13.11622,10.30147,10.30147,0,0,1,.27-1.04589l-36.25-42.87305a8.54468,8.54468,0,0,1-.59448-10.18457l.06567-.08008,32.62939-32.17383a9.43208,9.43208,0,1,1,13.12061,13.55274l-23.63232,22.46679,25.87158,41.52344a10.47053,10.47053,0,0,1,1.45923.17969,11.00243,11.00243,0,0,1-2.13257,21.792Z",
    transform: "translate(-294.25191 -177.5)",
    fill: "#a0616a"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "220.819 532.422 233.079 532.421 238.911 485.133 220.817 485.134 220.819 532.422",
    fill: "#a0616a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M511.94374,705.919l24.1438-.001h.001A15.38605,15.38605,0,0,1,551.475,721.30429v.5l-39.53051.00146Z",
    transform: "translate(-294.25191 -177.5)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "98.963 515.471 109.497 521.743 138.702 484.096 123.155 474.84 98.963 515.471",
    fill: "#a0616a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M392.57612,687.932l20.74515,12.35159.00084.00049a15.386,15.386,0,0,1,5.34836,21.09206l-.25581.4296-33.96586-20.2233Z",
    transform: "translate(-294.25191 -177.5)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M530.22354,693.21944H516.49527a4.49181,4.49181,0,0,1-4.47461-4.02442L498.18057,559.09834a1.50029,1.50029,0,0,0-2.85889-.459l-24.96777,55.28613-44.2041,72.08008a4.52141,4.52141,0,0,1-5.64844,1.76562l-17.65918-7.76953a4.50135,4.50135,0,0,1-2.05078-6.42773l40.63574-68.041,12.46265-57.32812c-3.91968-24.86133,12.88379-61.82324,13.0542-62.19434l.08325-.18066,50.52564-20.21094.23217.28418c30.02271,36.64844,25.137,126.48731,16.92408,223.19336A4.53045,4.53045,0,0,1,530.22354,693.21944Z",
    transform: "translate(-294.25191 -177.5)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M465.1625,491.88741l-.21557-.45313c-.103-.2168-10.395-21.92383-18.32886-45.124a34.22092,34.22092,0,0,1,2.3728-27.42481,34.59433,34.59433,0,0,1,22.06055-16.96386h0a34.63631,34.63631,0,0,1,40.2019,20.74316c6.29322,15.7373,8.52735,30.415,6.6399,43.625l-.0376.26465-.24072.11523Z",
    transform: "translate(-294.25191 -177.5)",
    fill: "#c29879"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M551.58448,527.10385a11.31758,11.31758,0,0,1-8.67711,4.2501h0a11.30718,11.30718,0,0,1-11.45875-11.61186,10.8998,10.8998,0,0,1,.17967-1.65988L483.265,428.0066a9.05214,9.05214,0,1,1,15.405-9.51l47.247,90.70721a11.29459,11.29459,0,0,1,5.66747,17.90006Z",
    transform: "translate(-294.25191 -177.5)",
    fill: "#a0616a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M504.39834,354.21944h-39v-17c8.56006-3.40076,16.93653-6.29291,22,0a17.00009,17.00009,0,0,1,17,17Z",
    transform: "translate(-294.25191 -177.5)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M463.23916,334.21944c-23.31494,0-29.84082,29.22436-29.84082,45.7113,0,9.19458,4.15821,12.48315,10.69239,13.59589l2.30761-12.30719,5.40479,12.83679c1.83545.00915,3.76367-.02637,5.76269-.06348l1.83252-3.77331,4.08643,3.70562c16.3667.02436,29.59473,2.41016,29.59473-13.99432C493.0795,363.4438,487.35635,334.21944,463.23916,334.21944Z",
    transform: "translate(-294.25191 -177.5)",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 380.49618,
    cy: 151,
    r: 8,
    fill: "#ccc"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M879.94487,425.78369a25.80322,25.80322,0,1,1,25.80322-25.80322A25.83228,25.83228,0,0,1,879.94487,425.78369Zm0-49.60644a23.80322,23.80322,0,1,0,23.80322,23.80322A23.83015,23.83015,0,0,0,879.94487,376.17725Z",
    transform: "translate(-294.25191 -177.5)",
    fill: "#c29879"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "b9831659-891b-45a6-8adc-1a9375a374c9-718",
    "data-name": "Path 395",
    d: "M877.48708,409.442a2.57246,2.57246,0,0,1-1.5476-.51433l-.02769-.02077-5.82907-4.459a2.59039,2.59039,0,1,1,3.1521-4.11155l3.77561,2.8953,8.92195-11.63967a2.5893,2.5893,0,0,1,3.63033-.47952l.00075.00056-.05537.07689.05687-.07689a2.59244,2.59244,0,0,1,.47895,3.63106L879.54974,408.4287a2.59083,2.59083,0,0,1-2.06038,1.01021Z",
    transform: "translate(-294.25191 -177.5)",
    fill: "#c29879"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M876.74809,329.5h-176a1,1,0,0,1,0-2h176a1,1,0,0,1,0,2Z",
    transform: "translate(-294.25191 -177.5)",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M876.74809,348.5h-176a1,1,0,0,1,0-2h176a1,1,0,0,1,0,2Z",
    transform: "translate(-294.25191 -177.5)",
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M876.74809,367.5h-176a1,1,0,0,1,0-2h176a1,1,0,0,1,0,2Z",
    transform: "translate(-294.25191 -177.5)",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M836.74809,386.5h-136a1,1,0,0,1,0-2h136a1,1,0,0,1,0,2Z",
    transform: "translate(-294.25191 -177.5)",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M835.74809,405.5h-135a1,1,0,0,1,0-2h135a1,1,0,0,1,0,2Z",
    transform: "translate(-294.25191 -177.5)",
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 380.49618,
    cy: 8,
    r: 8,
    fill: "#ccc"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M879.94487,282.78369a25.80322,25.80322,0,1,1,25.80322-25.80322A25.83228,25.83228,0,0,1,879.94487,282.78369Zm0-49.60644a23.80322,23.80322,0,1,0,23.80322,23.80322A23.83015,23.83015,0,0,0,879.94487,233.17725Z",
    transform: "translate(-294.25191 -177.5)",
    fill: "#c29879"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "a4eaae8d-0473-4dfb-80cb-ce1489130d65-719",
    "data-name": "Path 395",
    d: "M877.48708,266.442a2.57246,2.57246,0,0,1-1.5476-.51433l-.02769-.02077-5.82907-4.459a2.59039,2.59039,0,1,1,3.1521-4.11155l3.77561,2.8953,8.92195-11.63967a2.5893,2.5893,0,0,1,3.63033-.47952l.00075.00056-.05537.07689.05687-.07689a2.59244,2.59244,0,0,1,.47895,3.63106L879.54974,265.4287a2.59083,2.59083,0,0,1-2.06038,1.01021Z",
    transform: "translate(-294.25191 -177.5)",
    fill: "#c29879"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M876.74809,186.5h-176a1,1,0,0,1,0-2h176a1,1,0,0,1,0,2Z",
    transform: "translate(-294.25191 -177.5)",
    fill: "#3f3d56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M876.74809,205.5h-176a1,1,0,0,1,0-2h176a1,1,0,0,1,0,2Z",
    transform: "translate(-294.25191 -177.5)",
    fill: "#3f3d56"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M876.74809,224.5h-176a1,1,0,0,1,0-2h176a1,1,0,0,1,0,2Z",
    transform: "translate(-294.25191 -177.5)",
    fill: "#3f3d56"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M836.74809,243.5h-136a1,1,0,0,1,0-2h136a1,1,0,0,1,0,2Z",
    transform: "translate(-294.25191 -177.5)",
    fill: "#3f3d56"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M835.74809,262.5h-135a1,1,0,0,1,0-2h135a1,1,0,0,1,0,2Z",
    transform: "translate(-294.25191 -177.5)",
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 380.49618,
    cy: 293,
    r: 8,
    fill: "#ccc"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M879.94487,567.78369a25.80322,25.80322,0,1,1,25.80322-25.80322A25.83228,25.83228,0,0,1,879.94487,567.78369Zm0-49.60644a23.80322,23.80322,0,1,0,23.80322,23.80322A23.83015,23.83015,0,0,0,879.94487,518.17725Z",
    transform: "translate(-294.25191 -177.5)",
    fill: "#e6e6e6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "a21ca558-fa96-4264-98a7-0764bc68c1d4-720",
    "data-name": "Path 395",
    d: "M877.48708,551.442a2.57246,2.57246,0,0,1-1.5476-.51433l-.02769-.02077-5.82907-4.45905a2.59039,2.59039,0,1,1,3.1521-4.11155l3.77561,2.8953,8.92195-11.63967a2.5893,2.5893,0,0,1,3.63033-.47952l.00075.00056-.05537.07689.05687-.07689a2.59244,2.59244,0,0,1,.47895,3.63106L879.54974,550.4287a2.59083,2.59083,0,0,1-2.06038,1.01021Z",
    transform: "translate(-294.25191 -177.5)",
    fill: "#e6e6e6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M876.74809,471.5h-176a1,1,0,0,1,0-2h176a1,1,0,0,1,0,2Z",
    transform: "translate(-294.25191 -177.5)",
    fill: "#3f3d56"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M876.74809,490.5h-176a1,1,0,0,1,0-2h176a1,1,0,0,1,0,2Z",
    transform: "translate(-294.25191 -177.5)",
    fill: "#3f3d56"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M876.74809,509.5h-176a1,1,0,0,1,0-2h176a1,1,0,0,1,0,2Z",
    transform: "translate(-294.25191 -177.5)",
    fill: "#3f3d56"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M836.74809,528.5h-136a1,1,0,0,1,0-2h136a1,1,0,0,1,0,2Z",
    transform: "translate(-294.25191 -177.5)",
    fill: "#3f3d56"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M835.74809,547.5h-135a1,1,0,0,1,0-2h135a1,1,0,0,1,0,2Z",
    transform: "translate(-294.25191 -177.5)",
    fill: "#3f3d56"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M680.51581,722.5h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-294.25191 -177.5)",
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPastcases);
export default __webpack_public_path__ + "static/media/pastcases.0a941cff6520b3d51fdd96d2b05c2bc0.svg";
export { ForwardRef as ReactComponent };